var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardInvitationSendGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.435,
    height: 50,
    viewBox: "0 0 45.435 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 178",
    d: "M29.94 321.214a2.015 2.015 0 0 0-2.609 0L6.558 338.869a2.005 2.005 0 0 0 1.374.544h41.406a2.005 2.005 0 0 0 1.374-.544z",
    transform: "translate(-5.918 -289.413)",
    style: {
      fill: "#e2e9f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 179",
    d: "m269.148 222.391 18.511 15.732a2.007 2.007 0 0 0 .64-1.47v-27.567z",
    transform: "translate(-242.864 -188.668)",
    style: {
      fill: "#d3dae4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 180",
    d: "m.64 238.123 18.511-15.732L0 209.086v27.567a2.007 2.007 0 0 0 .64 1.47z",
    transform: "translate(0 -188.668)",
    style: {
      fill: "#d3dae4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 181",
    d: "m.731 353.53 18.511-15.73-1.173-.815L.1 352.255a2.009 2.009 0 0 0 .631 1.276z",
    transform: "translate(-.09 -304.075)",
    style: {
      fill: "#bfcbd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 182",
    d: "m287.659 353.53-18.511-15.73 1.173-.815 17.969 15.272a2.009 2.009 0 0 1-.631 1.276z",
    transform: "translate(-242.864 -304.075)",
    style: {
      fill: "#bfcbd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 183",
    d: "M5.721 159.3v8.836L0 164.16z",
    transform: "translate(0 -143.742)",
    style: {
      fill: "#bfcbd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 184",
    d: "m0 199.868 5.721 3.974v-1.813l-4.547-3.159z",
    transform: "translate(0 -179.449)",
    style: {
      fill: "#93a6b9",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 185",
    d: "M406.677 159.3v8.836l5.721-3.974z",
    transform: "translate(-366.963 -143.742)",
    style: {
      fill: "#bfcbd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 186",
    d: "M406.676 202.029v1.813l5.721-3.974-1.174-1z",
    transform: "translate(-366.962 -179.449)",
    style: {
      fill: "#93a6b9",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 187",
    d: "m72.012 33.723 2.261-1.923a2.015 2.015 0 0 1 2.609 0l2.262 1.922 13.431-9.33V.5a.5.5 0 0 0-.5-.5H59.084a.5.5 0 0 0-.5.5v23.89z",
    transform: "translate(-52.86)",
    style: {
      fill: "#f8f9fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 188",
    d: "m74.262 33.723 2.261-1.923a2.015 2.015 0 0 1 2.609 0l2.262 1.922 13.431-9.33V.5a.5.5 0 0 0-.5-.5H61.334a.5.5 0 0 0-.5.5v23.89z",
    transform: "translate(-55.069)",
    style: {
      fill: "#f8915b",
      opacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 189",
    d: "m79.144 240.546-2.262-1.922a2.015 2.015 0 0 0-2.609 0l-2.262 1.922-13.43-9.33v1.813l13.431 9.33 2.262-1.922a2.015 2.015 0 0 1 2.609 0l2.262 1.922 13.431-9.33v-1.813z",
    transform: "translate(-52.819 -208.636)",
    style: {
      fill: "#b59e95",
      opacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 190",
    d: "m160.241 77.91 1.666 2.809a1.362 1.362 0 0 0 .873.634l3.187.717a1.362 1.362 0 0 1 .724 2.228l-2.157 2.453a1.362 1.362 0 0 0-.333 1.026l.3 3.252a1.362 1.362 0 0 1-1.9 1.377l-3-1.293a1.362 1.362 0 0 0-1.079 0l-3 1.293a1.362 1.362 0 0 1-1.9-1.377l.3-3.252a1.362 1.362 0 0 0-.333-1.026l-2.141-2.451a1.362 1.362 0 0 1 .724-2.228l3.187-.717a1.362 1.362 0 0 0 .873-.634l1.668-2.811a1.362 1.362 0 0 1 2.343 0z",
    transform: "translate(-136.352 -69.699)",
    style: {
      fill: "#7dcb60"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardInvitationSendGrey);
export default __webpack_public_path__ + "static/media/dashboard-invitation-send-grey.a075967db1f32cb5ecd68eaafda5e2a4.svg";
export { ForwardRef as ReactComponent };